import { StaticImageData } from 'next/image';
import bartoszBankowskiAvatar from '../../../public/webp/fromPNG/AlgeaTheme/thulium/bartosz-bankowski-avatar.webp';
import {
  StyledStack,
  StyledQuote,
  StyledTestimonial,
  TestimonialWrapper,
  CustomerTestimonialSection,
} from './styles';

export const Testimonial = () => {
  return (
    <CustomerTestimonialSection width="normal">
      <StyledStack>
        <StyledQuote variant="display_sm">“</StyledQuote>
        <TestimonialWrapper>
          <StyledTestimonial
            name="Bartosz Bańkowski"
            positionInCompany="Co-founder and Development Lead @ Thulium"
            text={`
              Cooperating with Rumble Fish was a pleasure! Everything went to
              plan with the implementation and we also came up with new ways
              to make improvements during the project. We felt that Thulium and
              Rumble Fish really worked as one during the project and the
              collaboration was very smooth. Having them on board with their
              technological savviness, experience in mobile solutions and
              design skills played a big part in the project’s overall success.
            `}
            avatarSrc={
              (bartoszBankowskiAvatar as unknown as StaticImageData)?.src || ''
            }
          />
        </TestimonialWrapper>
      </StyledStack>
    </CustomerTestimonialSection>
  );
};
